/*
 * @Author: wsx
 * @Date: 2022-01-15 16:39:06
 * @LastEditTime: 2022-01-23 14:58:05
 * @LastEditors: your name
 * @Description:
 */
export default [{
    path: "RealVideo",
    name: "RealVideo",
    component: () =>
      import ("@/views/videoControl/RealVideo.vue"),
    meta: {
      title: "实时视频"
    }
  },
  {
    path: "PlaybackVideo",
    name: "PlaybackVideo",
    component: () =>
      import ("@/views/videoControl/PlaybackVideo.vue"),
    meta: {
      title: "实时视频"
    }
  },
  {
    path: "FaceDetect",
    name: "FaceDetect",
    component: () =>
      import ("@/views/videoControl/FaceDetect.vue"),
    meta: {
      title: "人脸识别"
    }
  },
  {
    path: "RealTimeCar",
    name: "RealTimeCar",
    component: () =>
      import ("@/views/videoControl/RealTimeCar.vue"),
    meta: {
      title: "实时过车"
    }
  },
  {
    path: "VideoPlan",
    name: "VideoPlan",
    component: () =>
      import ("@/views/videoControl/VideoPlan/index.vue"),
    meta: {
      title: "视频巡逻"
    }
  }
];